class ReviewCard extends HTMLElement {
	render({ id = '', image = '', rating = 0, text = '', name = '', verified = false }) {
		this.classList.add('review-io-card');
		this.setAttribute('review-id', id);
		this.innerHTML = `
			<div class="review-io-card__image-wrapper">
				<img loading="lazy" src="${image}" alt="${name ? `Photo of ${name}` : 'customer photo'}">
			</div>
			<div class="review-io-card__content">
				<rating-stars class="review-io-card__rating" rating="${rating}"></rating-stars>
				<p class="review-text">${text}</p>
				<div class="review-io-card__author-wrapper">
				<span class="review-io-card__author">${name}</span>${
					verified
						? `${window.themeVariables.icons.verified}
				<button type="button" class="review-row-item__verified-info" aria-controls="verified-review-info-modal" aria-label="${window.themeVariables.strings.reviewsIo.verifiedInfoLabel}">\
					<svg aria-hidden="true" width="20" height="20" viewBox="0.5 0.5 23 23" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
						<circle cx="12" cy="12" r="10"/>
						<g fill="currentColor" stroke="none" transform="matrix(0.025 0 0 0.025 0 24)">
							<path d="M513.5-254.5Q528-269 528-290t-14.5-35.5Q499-340 478-340t-35.5 14.5Q428-311 428-290t14.5 35.5Q457-240 478-240t35.5-14.5ZM442-394h74q0-33 7.5-52t42.5-52q26-26 41-49.5t15-56.5q0-56-41-86t-97-30q-57 0-92.5 30T342-618l66 26q5-18 22.5-39t53.5-21q32 0 48 17.5t16 38.5q0 20-12 37.5T506-526q-44 39-54 59t-10 73Z"/>
						</g>
					</svg>
				</button>`
						: ''
				}
				</div>
			</div>
    `;
	}
}
if (!customElements.get('review-card')) {
	customElements.define('review-card', ReviewCard);
}
